import { Component, ElementRef, OnInit, inject, viewChild, signal } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Blog } from '../../../models/blog';
import { Works } from '../../../models/works';
import { FormControl } from '@angular/forms';
import { WorksService } from '../../../services/works.service';
import { ComuniService } from '../../../services/comuni.service';

import { SelectItem } from "primeng/api";
import * as moment from 'moment';
import { Comuni } from 'src/app/models/comuni';
import { Tags } from 'src/app/models/tags';
import { TagsService } from 'src/app/services/tags.service';
import { PersonalDataService } from 'src/app/services/personal_data.service';
import { Bind } from 'primeng/bind';
import { Card } from 'primeng/card';
import { ButtonDirective } from 'primeng/button';
import { InputText } from 'primeng/inputtext';

import { TranslatePipe } from '@ngx-translate/core';

import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-personal-data-form',
    templateUrl: './personal-data-form.component.html',
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, Card, ButtonDirective, InputText, TranslatePipe]
})
export class PersonalDataFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private personalDataService = inject(PersonalDataService);
  private comuniService = inject(ComuniService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly myInputVariable = viewChild<ElementRef>("myInput");

  readonly pageTitle = signal<string>(undefined);
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  imagePath: any;
  tags: Tags;
  tag: Tags;

  comuni: Comuni;

  checked: boolean = true;
  selectedValue: string;

  categoryForm: UntypedFormGroup;

  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedWorks: Works;
  readonly selectedDate = signal<Date>(undefined);
  date: Date;
  readonly currentUser = signal<any>(undefined);

  constructor() {
    if (this.date) {
      this.selectedDate.set(new Date(this.date));
    }

    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));

  }

  ngOnInit() {

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {

      this.pageTitle.set('Modifica Tipo di lavorazione');
      this.personalDataService.getId(id).subscribe(
        res => {
          this.categoryForm.patchValue({
            name: res.name,
            description: res.description,
            user_id: this.currentUser().user_id,
            id: res.id
          });

        }
      );
    } else {
      this.pageTitle.set('Create Category');
    }

    this.categoryForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      description: [''],
      user_id: [this.currentUser().user_id]

    });
  }

  get name() {
    return this.categoryForm.get('name');
    return this.categoryForm.get('description');

  }

  onSubmit() {

    const formData = new FormData();

    formData.append('name', this.categoryForm.get('name').value);
    formData.append('description', this.categoryForm.get('description').value);
    formData.append('user_id', this.categoryForm.get('user_id').value);

    const id = this.categoryForm.get('id').value;

    if (id) {
      this.personalDataService.update(formData, id).subscribe(
        res => {
          if (res.status == 'error') {
            this.uploadError.set(res.message);
          } else {
            this.router.navigate(['/admin/settings/personal-data']);
          }
        },
        error => this.error.set(error)
      );
    } else {
      this.personalDataService.create(formData).subscribe(
        res => {
          if (res.status === 'error') {
            this.uploadError.set(res.message);
          } else {
            this.router.navigate(['/admin/settings/personal-data']);
          }
        },
        error => this.error.set(error)
      );
    }

  }

}
